export const FORM_SUBMISSIONS_LOAD_ERROR = 'Could not load form submissions.';

export const FEEDS_FORMS_TAB_ROUTE = '/feeds#forms';
